export enum BillingType {
  SUBSCRIPTION = "SUBSCRIPTION",
  WITHDRAWAL = "WITHDRAWAL",
  ADDITIONAL_CARD = "ADDITIONAL_CARD",
  ADDITIONAL_TRANSACTION = "ADDITIONAL_TRANSACTION",
}
